import { classNames } from '../../utils/style-class.utils';
export var solid = 'inline-flex items-center border-2 border-transparent text-sm font-normal shadow-sm justify-center outline-none';
export var outline = 'inline-flex items-center border-2 border-solid shadow-sm text-sm font-semibold justify-center outline-none';
export var ghost = 'inline-flex items-center text-sm font-semibold justify-center outline-none';
export var disabledSolid = 'bg-uiLight';
export var disabledOutline = 'border-uiLight shadow-sm text-sm font-semibold text-uiLight bg-white';
export var disabledghost = 'font-semibold text-uiLight';
export var rounded = 'rounded-full';
export var getButtonClassName = function (type, disabled, color, shape, size, background) {
    var className = '';
    switch (type) {
        case 'filled':
            className = classNames(solid, disabled
                ? "bg-".concat(color, " text-white opacity-50")
                : "bg-".concat(color, " text-white"));
            break;
        case 'outlined':
            className = classNames(outline, disabled
                ? "shadow-sm text-sm font-semibold text-uiLight bg-white border-".concat(color, " opacity-50")
                : "border-".concat(color, " text-").concat(color, " bg-").concat(background === 'filled' ? 'white' : 'transparent'));
            break;
        case 'ghost':
            className = classNames(ghost, "text-".concat(color), disabled ? disabledghost : '');
            break;
        default:
            className = classNames(solid, "text-white bg-tertiaryAccent1");
            break;
    }
    var sizeStyle = '';
    switch (size) {
        case 'small':
            sizeStyle = 'py-2 px-2';
            break;
        case 'large':
            sizeStyle = 'py-2 px-5';
            break;
        case 'large-round':
            sizeStyle = 'py-2.5 px-2.5';
            break;
        case 'normal':
        default:
            sizeStyle = 'py-2.5 px-17';
            break;
    }
    var roundedStyle = shape === 'round' ? rounded : '';
    switch (size) {
        case 'small':
            if (roundedStyle)
                break;
            roundedStyle = 'rounded-10';
            break;
        default:
            if (roundedStyle)
                break;
            roundedStyle = 'rounded-15';
            break;
    }
    className = classNames(className, sizeStyle, roundedStyle);
    return className;
};
//# sourceMappingURL=button.styles.js.map